import { getRSqlBySearch, isObjectValueType } from '@helpers'
import { FIELD_VALUE_TYPE } from '@constants'
import { POSTObjectDataFilter, TimeLineDTOType } from '@types'

export const getObjectXSAExtraRsqlFilters = ({
  config,
  objectYSAFiltersCriteria,
  objectXColumnsObjectSAFiltersCriteria,
}: {
  config: TimeLineDTOType
  objectYSAFiltersCriteria?: POSTObjectDataFilter
  objectXColumnsObjectSAFiltersCriteria?: POSTObjectDataFilter
}): string[] => {
  const saExtraFilters: string[] = []

  const linkToObjectYRef = config.objectX.linkToObjectY.findLast(item =>
    isObjectValueType(item.valueType)
  )

  const linkToColumnsObjectRef = config.objectX.linkToColumnsObject?.findLast(item =>
    isObjectValueType(item.valueType)
  )

  if (
    linkToObjectYRef &&
    objectYSAFiltersCriteria &&
    linkToObjectYRef.model === config.objectY.objectCode
  ) {
    const objectYFiltersForObjectX =
      getRSqlBySearch(
        objectYSAFiltersCriteria.map(item => ({
          ...item,
          valueName: `${linkToObjectYRef.field}.${item.valueName}`,
        }))
      ) || ''

    if (objectYFiltersForObjectX) {
      saExtraFilters.push(objectYFiltersForObjectX)
    }
  }

  if (linkToColumnsObjectRef && objectXColumnsObjectSAFiltersCriteria) {
    const columnsObjectFiltersForObjectX =
      getRSqlBySearch(
        objectXColumnsObjectSAFiltersCriteria
          .filter(item => item.linkedObjectCode === linkToColumnsObjectRef.model)
          .map(item => {
            if (isObjectValueType(item.valueType as FIELD_VALUE_TYPE)) {
              return {
                ...item,
                valueName: `${linkToColumnsObjectRef.field}`,
              }
            }

            return {
              ...item,
              valueName: `${linkToColumnsObjectRef.field}.${item.valueName}`,
            }
          })
      ) || ''

    if (columnsObjectFiltersForObjectX) {
      saExtraFilters.push(columnsObjectFiltersForObjectX)
    }
  }

  return saExtraFilters
}
